const r = {
  "cdr-breadcrumb": "cdr-breadcrumb_15-1-0",
  "cdr-breadcrumb__list": "cdr-breadcrumb__list_15-1-0",
  "cdr-breadcrumb__item": "cdr-breadcrumb__item_15-1-0",
  "cdr-breadcrumb__link": "cdr-breadcrumb__link_15-1-0",
  "cdr-breadcrumb__delimiter": "cdr-breadcrumb__delimiter_15-1-0",
  "cdr-breadcrumb__ellipses": "cdr-breadcrumb__ellipses_15-1-0",
  "cdr-breadcrumb__ellipses-icon": "cdr-breadcrumb__ellipses-icon_15-1-0"
};
export {
  r as default
};
